import React, { useState, useEffect, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import GamesStore from 'stores/GamesStore';
import RollTheDice from 'components/RollTheDice/RollTheDice';
import SpinTheWheel from 'components/SpinTheWheel/SpinTheWheel';
import TokenKeno from 'components/TokenKeno/TokenKeno';


function GamesTab(props) {
  const {
    embedProfileV2,
    match,
    paymentActions: { showBuyTokensModal },
    setShowRegistrationModal,
    user,
    walletDetails,
  } = props;

  const { username } = user;

  const {
    anyGameActive,
    rollTheDiceActive,
    spinTheWheelActive,
    tokenKenoActive,
  } = GamesStore;

  const [gameDrawerOpen, setGameDrawerOpen] = useState(false);

  const balance = walletDetails.get('balance');
  const roomName = match.params.user;

  const toggleGameDrawer = useCallback(() => {
    setGameDrawerOpen(!gameDrawerOpen);
  }, [gameDrawerOpen]);

  useEffect(() => {
    if (!anyGameActive && gameDrawerOpen) {
      toggleGameDrawer();
    }
  }, [
    anyGameActive,
    gameDrawerOpen,
    toggleGameDrawer,
  ]);

  return (
    <Fragment>
      {spinTheWheelActive && (
        <SpinTheWheel
          balance={balance}
          embedProfileV2={embedProfileV2}
          isDesktop={true}
          roomName={roomName}
          setShowRegistrationModal={setShowRegistrationModal}
          showBuyTokensModal={showBuyTokensModal}
          user={user}
        />
      )}
      {tokenKenoActive && (
        <TokenKeno
          embedProfileV2={embedProfileV2}
          isDesktop={true}
          roomName={roomName}
          setShowRegistrationModal={setShowRegistrationModal}
          showBuyTokensModal={showBuyTokensModal}
          user={user}
        />
      )}
      {rollTheDiceActive && (
        <RollTheDice
          embedProfileV2={embedProfileV2}
          isDesktop={true}
          roomName={roomName}
          setShowRegistrationModal={setShowRegistrationModal}
          showBuyTokensModal={showBuyTokensModal}
          username={username}
        />
      )}
    </Fragment>
  );
}

GamesTab.propTypes = {
  match: PropTypes.object.isRequired,
  paymentActions: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  walletDetails: PropTypes.object.isRequired,
  embedProfileV2: PropTypes.bool,
  setShowRegistrationModal: PropTypes.func,
};

GamesTab.defaultProps = {
  embedProfileV2: false,
  setShowRegistrationModal: () => undefined,
};

export default observer(GamesTab);
